import './style.css';

// --- Shared constants (re-exported from constants.ts to avoid circular deps) ---
export { API_BASE, REPOS, CARD_REPOS, OWNER } from './js/constants.ts';

// Re-export from config for backward compat
export { reducedMotion, isMobile } from './js/config.ts';

// --- Module imports ---
import { init as initTheme } from './js/theme.ts';
import { init as initNav } from './js/nav.ts';
import { init as initCarousel } from './js/carousel.ts';
import { init as initLightbox } from './js/lightbox.ts';
import { init as initParallax } from './js/parallax.ts';
import { init as initCards } from './js/cards.ts';
import { init as initScroll } from './js/scroll.ts';
import { init as initFilter } from './js/filter.ts';

// --- Initialize above-fold modules ---
initTheme();
initNav();
initCarousel();
initLightbox();
initParallax();
initCards();
initScroll();
initFilter();

// --- Lazy-load below-fold modules ---
try {
  const [stats, timeline, activeRepos] = await Promise.all([
    import('./js/stats.ts'),
    import('./js/timeline.ts'),
    import('./js/active-repos.ts'),
  ]);
  stats.init();
  timeline.init();
  activeRepos.init();
} catch (e) {
  console.warn('Failed to load below-fold modules', e);
}

// --- Register service worker (production only) ---
// In dev the SW would cache unhashed source modules and serve stale code
// across sessions; unregister any leftover one to heal poisoned dev setups.
if ('serviceWorker' in navigator) {
  if (import.meta.env.DEV) {
    navigator.serviceWorker.getRegistrations().then((regs) => {
      for (const reg of regs) reg.unregister();
    });
  } else {
    navigator.serviceWorker.register('/sw.js');
  }
}
